import { gql } from "@apollo/client";

// 관리자 전용 JWT 기반 로그인
export const MANAGER_LOGIN_MUTATION = gql`
  mutation ManagerLogin($id: String!, $userPw: String!) {
    managerLogin(id: $id, userPw: $userPw) {
      accessToken
      refreshToken
      expiresIn
      tokenType
      deviceId
      user {
        id
        userName
        authority
        recommendCode
        isOverDomestic
        isOverOption
        isOverForeign
        isOverHangSeng
        domestic_fee
        option_fee
        foreign_fee
        hangseng_fee
        mini_foreign_fee
        mini_hangseng_fee
        domestic_maxAvailableCount
        option_maxAvailableCount
        foreign_maxAvailableCount
        hangseng_maxAvailableCount
        mini_foreign_maxAvailableCount
        mini_hangseng_maxAvailableCount
        userAccountBank
        userAccountNo
        userAccountOwner
        position {
          orderNo
          itemCode
          isBuy
          count
          price
          isSigned
          type
        }
        connectState
        connect_server {
          id
          name
          server
        }
        user_balance_history {
          dateId
          userBalance
        }
      }
    }
  }
`;

// 일반 사용자 JWT 기반 로그인
export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      accessToken
      refreshToken
      expiresIn
      tokenType
      user {
        id
        userName
        authority
        recommendCode
        isOverDomestic
        isOverOption
        isOverForeign
        isOverHangSeng
        domestic_fee
        option_fee
        foreign_fee
        hangseng_fee
        mini_foreign_fee
        mini_hangseng_fee
        domestic_maxAvailableCount
        option_maxAvailableCount
        foreign_maxAvailableCount
        hangseng_maxAvailableCount
        mini_foreign_maxAvailableCount
        mini_hangseng_maxAvailableCount
        userAccountBank
        userAccountNo
        userAccountOwner
        position {
          orderNo
          itemCode
          isBuy
          count
          price
          isSigned
          type
        }
        connectState
        connect_server {
          id
          name
          server
        }
        user_balance_history {
          dateId
          userBalance
        }
      }
    }
  }
`;

// 로그아웃
export const LOGOUT_MUTATION = gql`
  mutation Logout($deviceId: String) {
    logout(deviceId: $deviceId) {
      success
      message
    }
  }
`;

// 토큰 갱신
export const REFRESH_TOKEN_MUTATION = gql`
  mutation RefreshToken($input: RefreshTokenInput!) {
    refreshToken(input: $input) {
      accessToken
      refreshToken
      expiresIn
      tokenType
      deviceId
      user {
        id
        userName
        authority
      }
    }
  }
`;

// 토큰 검증
export const VALIDATE_TOKEN_QUERY = gql`
  query ValidateToken {
    validateToken {
      valid
      user {
        id
        userName
        authority
      }
      expiresAt
    }
  }
`;

// 활성 세션 조회
export const ACTIVE_SESSIONS_QUERY = gql`
  query ActiveSessions {
    activeSessions {
      deviceId
      deviceName
      createdAt
      lastActivity
      ipAddress
      userAgent
      isCurrent
    }
  }
`;

// 강제 로그아웃 구독
export const FORCE_LOGOUT_SUBSCRIPTION = gql`
  subscription ForceLogout($userId: String!) {
    forceLogout(userId: $userId) {
      userId
      deviceId
      reason
      message
      timestamp
    }
  }
`;